<!-- <ng-container *ngIf="isActive">
  <ng-container *ngIf="activeDirection === 'asc'">
    <i class="fas fa-sort-amount-up ms-1"></i>
  </ng-container>
  <ng-container *ngIf="activeDirection === 'desc'">
    <i class="fas fa-sort-amount-down ms-1"></i>
  </ng-container>
</ng-container>
<ng-container *ngIf="!isActive">
  <i class="fas fa-sort-alt ms-1"></i>
</ng-container> -->

<ng-container *ngIf="isActive">
  <ng-container *ngIf="activeDirection === 'asc'">
    <!-- <span
      [inlineSVG]="'./assets/media/svg/icons/Navigation/Up-2.svg'"
      [cacheSVG]="true"
      class="svg-icon svg-icon-xs svg-icon-primary ms-1"
    >
    </span> -->
    <i class="fas fa-sort-amount-up-alt ms-2"></i>
  </ng-container>
  <ng-container *ngIf="activeDirection === 'desc'">
    <!-- <span
      [inlineSVG]="'./assets/media/svg/icons/Navigation/Down-2.svg'"
      [cacheSVG]="true"
      class="svg-icon svg-icon-xs svg-icon-primary ms-1"
    >
    </span> -->
    <i class="fas fa-sort-amount-down ms-2"></i>
  </ng-container>
</ng-container>

<ng-container *ngIf="!isActive">
  <!-- <span
    [inlineSVG]="'./assets/media/svg/icons/Shopping/Sort1.svg'"
    [cacheSVG]="true"
    class="svg-icon svg-icon-xs svg-icon-primary ms-1 svg-icon-sort"
  >
  </span> -->
  <i class="fas fa-sort ms-2"></i>
</ng-container>
